import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Document, Page } from "react-pdf";
import exportFromBlob from "helpers/export-from-blob";

class PdfViewerModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            numPages: null,
            pageNumber: 1,
            file: this.createFile(this.props.pdfData)
        };

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleSaveFile = this.handleSaveFile.bind(this);
        this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.pdfData, this.props.pdfData)) {
            this.setState({
                file: this.createFile(nextProps.pdfData)
            });
        }
    }

    handleChangePage = (ev) => {
        this.setState({
            pageNumber: Math.max(1, Math.min(ev.target.value, this.state.numPages))
        });
    };

    handleSaveFile = () => {
        exportFromBlob(this.props.pdfData, this.props.name || "file.pdf");
    };

    createFile = (pdfData) => {
        const file = new Blob([pdfData], {
            type: "application/pdf"
        });
        return URL.createObjectURL(file);
    };

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    };

    getPagerComponent = () => {
        const {
            pageNumber,
            numPages
        } = this.state;
        return (
            <div className="form-inline justify-content-center mt-2 mb-2">
                Page
                <div className="form-group ml-1 mr-1">
                    <input
                        type="number"
                        value={pageNumber}
                        className="form-control form-control-sm"
                        onChange={this.handleChangePage}
                    />
                </div>
                of {numPages}
            </div>
        );
    };

    render() {
        const {
            file,
            pageNumber,
        } = this.state;

        const pagerComponent = this.getPagerComponent();

        return (
            <div
                className="position-relative"
                style={{
                    overflow: "hidden"
                }}
            >
                {pagerComponent}

                <div className="text-center">
                    <Document
                        file={file}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                        className="d-flex justify-content-center w-auto"
                    >
                        <Page
                            width={1000}
                            pageNumber={pageNumber}
                        />
                    </Document>
                </div>

                {pagerComponent}

                <div className="text-right">
                    <button
                        className="btn btn-success"
                        onClick={this.handleSaveFile}
                    >
                        Export
                    </button>
                </div>
            </div>
        );
    }
}

PdfViewerModal.propTypes = {
    pdfData: PropTypes.any.isRequired
};

export default PdfViewerModal;
